var path = 'app/admin/admin.html';
var html = "<section id=\"admin\" class=\"section-cont\">\n\t<div ui-view class=\"page-content\"></div>\n</section>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/admin/admin.html
// module id = ./app/admin/admin.html
// module chunks = 0